import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const SectionHeader = ({ label }) => {
	return (
		<Box
			sx={{
				position: 'sticky',
				top: 0,
				zIndex: 1,
				backgroundColor: 'background.subtle',
				padding: '6px 15px 4px',
				borderBottom: '0.5px solid',
				borderTop: '0.5px solid',
				borderColor: 'border.light',
			}}
		>
			<Typography
				sx={{
					fontSize: '10px',
					fontWeight: 600,
					color: 'text.secondary',
					letterSpacing: '0.05em',
					textTransform: 'uppercase',
				}}
			>
				{label}
			</Typography>
		</Box>
	);
};

SectionHeader.propTypes = {
	label: PropTypes.string.isRequired,
};

export default SectionHeader;
